import { createContext, useContext } from "react";

interface TourContextValue {
  startTour: () => void;
}

export const TourContext = createContext<TourContextValue>({
  startTour: () => {},
});

export function useTourContext() {
  return useContext(TourContext);
}
